import useAuth from '@/auth/useAuth';
import LinkService from './LinkService';
import OverviewVisualization from './visualization';
import siteConfig from '@/config';
import Changelog from './changelog';
import { Separator } from '@/components/ui/separator';
import { useDemoMode } from '@/context/DemoModeContext';
import WorkspaceOverview from './WorkspaceOverview';
import { CreateWorkspaceDialog } from '@/features/demo-workspace/components/CreateWorkspaceDialog';

interface DashboardOverviewProps {
  isOverviewMode?: boolean;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({ isOverviewMode = false }) => {
  const { session } = useAuth();
  const { isDemoMode } = useDemoMode();

  // Overview mode - show all workspaces with quotas
  if (isOverviewMode) {
    return (
      <div className="container mt-8">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-2xl font-medium">Dashboard</p>
            <p className="text-base text-muted-foreground">
              {isDemoMode ? 'Demo User' : session?.user?.email}
            </p>
          </div>
          {isDemoMode && <CreateWorkspaceDialog />}
        </div>
        <div className="mt-8">
          <WorkspaceOverview showAll />
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-8">
      <p className="text-2xl font-medium">Welcome</p>
      <p className="text-base text-muted-foreground">{session?.user?.email}</p>

      {isDemoMode && (
        <div className="mt-8">
          <WorkspaceOverview />
        </div>
      )}

      <div className="mt-12 flex flex-col gap-12">
        <LinkService />
        {siteConfig.services.llm && <OverviewVisualization />}
      </div>
      {!isDemoMode && (
        <>
          <Separator className="mt-12" />
          <section className="py-12">
            <Changelog />
          </section>
        </>
      )}
    </div>
  );
};

export default DashboardOverview;
